import { render, staticRenderFns } from "./SamTable.vue?vue&type=template&id=2e4a6010&scoped=true&shadow"
import script from "./SamTable.vue?vue&type=script&lang=js&shadow"
export * from "./SamTable.vue?vue&type=script&lang=js&shadow"
function injectStyles (context) {
  
  var style0 = require("./SamTable.vue?vue&type=style&index=0&id=2e4a6010&prod&lang=scss&scoped=true&shadow")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "2e4a6010",
  null
  ,true
)

export default component.exports